// src/customer/customer-policy/customer-policy-commission/ReconciledCard.tsx

import React from "react";
import { Panel, Row, Column } from "../../../components";
import { Badge } from "primereact/badge";
import { FloatingLabel, Form } from "react-bootstrap";
import { IReconciledRecord } from "./models/CommissionTypes";
import { fomratWithCommasAndDecimals } from "../../../shared/util/currencyUtils";

interface IReconciledCardProps {
  data: IReconciledRecord;
}

const ReconciledCard: React.FC<IReconciledCardProps> = ({ data }) => {
  return (
    <Panel
      title="RECONCILED"
      className="commission-card-reconciled commission-panel-header"
      panelHeaderItems={
        <>
          {data.badges.map((badge, index) => (
            <Badge key={index} severity="info" value={badge} className="p-badge p-component p-badge-no-gutter ul-truncate-p-badge" />
          ))}
          <span className="commission-card-date ms-auto">
            TRANS EFFECTIVE DATE {data.transEffectiveDate}
          </span>
        </>
      }
    >
      <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="reconciledNonCommissionablePremium" label="Reconciled Non-Commissionable Premium">
              <Form.Control
                type="text"
                name="reconciledNonCommissionablePremium"
                value={`$${fomratWithCommasAndDecimals(data.reconciledNonCommissionablePremium)}`}
                placeholder="Reconciled Non-Commissionable Premium"
                disabled
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="reconciledCommissionablePremium" label="Reconciled Commissionable Premium">
              <Form.Control
                type="text"
                name="reconciledCommissionablePremium"
                value={`$${fomratWithCommasAndDecimals(data.reconciledCommissionablePremium)}`}
                placeholder="Reconciled Commissionable Premium"
                disabled
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row className="mb-3">
          <Column lg={6} md={6}>
            <FloatingLabel controlId="reconciledCommissions" label="Reconciled Commissions">
              <Form.Control
                type="text"
                name="reconciledCommissions"
                value={`$${fomratWithCommasAndDecimals(data.reconciledCommissions)}`}
                placeholder="Reconciled Commissions"
                disabled
              />
            </FloatingLabel>
          </Column>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="reconciledFees" label="Reconciled Fees">
              <Form.Control
                type="text"
                name="reconciledFees"
                value={`$${fomratWithCommasAndDecimals(data.reconciledFees)}`}
                placeholder="Reconciled Fees"
                disabled
              />
            </FloatingLabel>
          </Column>
        </Row>
        <Row>
          <Column lg={6} md={6}>
            <FloatingLabel controlId="reconciledTaxes" label="Reconciled Taxes">
              <Form.Control
                type="text"
                name="reconciledTaxes"
                value={`$${fomratWithCommasAndDecimals(data.reconciledTaxes)}`}
                placeholder="Reconciled Taxes"
                disabled
              />
            </FloatingLabel>
          </Column>
        </Row>
    </Panel>
  );
};

export default ReconciledCard;
